// .p-top-mv__marquee 内のGIFアニメーション（walker-1.gif / walker-2.gif）を
// ロード完了のタイミングでフレーム0から再生し直す。
// srcを一旦空にしてから元の値へ戻すと、キャッシュ済みでもブラウザがデコード状態をリセットして
// 最初のフレームから再生し直す（src文字列を同じ値のまま再代入するだけでは多くのブラウザで無視される）。
export const restartMarqueeGifs = (): void => {
  const imgs = document.querySelectorAll<HTMLImageElement>(".p-top-mv-marquee__img img");

  imgs.forEach((img) => {
    const src = img.getAttribute("src");
    if (!src) return;

    img.setAttribute("src", "");
    img.setAttribute("src", src);

    const container = img.closest<HTMLElement>(".p-top-mv-marquee__img") ?? img;
    container.classList.add("--play");
  });
};
